export type AssistantPanelKind = 'genogram' | 'flowchart' | 'org' | 'network';

export interface AssistantMountPolicyInput {
  readonly isEmbedMode: boolean;
  readonly showAssistant: boolean;
  readonly isDiagramTypeResolved: boolean;
  readonly diagramType: string | null | undefined;
}

export function resolveAssistantPanelKind({
  isEmbedMode,
  showAssistant,
  isDiagramTypeResolved,
  diagramType,
}: AssistantMountPolicyInput): AssistantPanelKind | null {
  if (isEmbedMode || !showAssistant || !isDiagramTypeResolved) {
    return null;
  }

  if (
    diagramType === 'genogram' ||
    diagramType === 'flowchart' ||
    diagramType === 'org' ||
    diagramType === 'network'
  ) {
    return diagramType;
  }

  return null;
}
